'use strict';

MultiFragmentGridGridFactory.$inject = [
	'$q',
	'mx.SolutionBuilderAgent.DynamicGrid',
	'mx.SolutionBuilderAgent.BaseGrid',
	'mx.SolutionBuilderAgent.MxGridHelperService',
	'mx.SolutionBuilderAgent.GridEnums',
];
export default function MultiFragmentGridGridFactory($q, DynamicGrid, BaseGrid, gridHelperService, GridEnums) {
	class MultiFragmentGrid extends DynamicGrid {
		constructor() {
			super();
		}

		initProperties() {
			BaseGrid.prototype.initProperties.apply(this);

			var objectId,
				data = [];

			Object.defineProperties(this, {
				items: {
					get: function () {
						return data;
					},
				},
				data: {
					configurable: true,
					get: function () {
						return data;
					},
					set: function (newData) {
						if (newData instanceof mx.SolutionBuilderAgent.DataModelMultiFragmentArray) {
							data = newData;
							data.onChange(
								function (arr, fName, args) {
									//don't reload data if it is internal adding new item
									if (this._internalCreatingEntity && fName === 'push' && this._internalCreatingEntity === args[0]) {
										return;
									}
									this.updateRequest();
									this.debouncedLoadItems();
								}.bind(this)
							);

							this.updateRequest();
							this.debouncedLoadItems();
						}

						//temporary for entity as service
						//TODO: refactor this after using DataModelArray
						if (Array.isArray(newData)) {
							data = newData;
							this.updateRequest();
							this.debouncedLoadItems();
						}
					},
				},

				objectId: {
					enumerable: true,
					get: function () {
						//TODO: get objectId from DataModel as in RelationGrid (to support Wizards as well)
						return objectId || (this.data && this.data.objectId);
					},
					set: function (newObjectId) {
						objectId = newObjectId;

						this.updateRequest();
						this.debouncedLoadItems();
					},
				},
				columnDefinition: {
					writable: true,
				},
				entityClassName: {
					configurable: true,
					writable: true,
				},
			});
		}

		async initDataQuery() {
			return gridHelperService.initDQByDefinition(this.columnDefinition, this.entityClassName, GridEnums.DataDefinitionGridTypes.MultiFragment);
		}

		updateRequest() {
			if (this.executor) {
				this.executor.updateRequestOptions({
					items: this.items,
					objectId: this.objectId,
					entityClassName: this.entityClassName,
					columnDefinition: this.columnDefinition,
					entityName: this.serviceContext.mxServiceContext.entityName,
					hideItemFieldName: this.hideItemFieldName,
				});
			}
		}

		afterEntitiesCreated(/*entities*/) {
			this._internalCreatingEntity = null;

			if (this.data instanceof mx.SolutionBuilderAgent.DataModelMultiFragmentArray) {
				return;
			}

			//temporary for entity as service
			//TODO: refactor this after using DataModelArray
			if (typeof this.items.changed === 'function') {
				this.items.changed();
			}
		}

		removeEntities(entities) {
			this._removeEntitiesFromData(entities);

			// updateRequest and loadData is loaded automatically from onChange
			if (this.data instanceof mx.SolutionBuilderAgent.DataModelMultiFragmentArray) {
				return $q.when();
			}

			//temporary for entity as service
			//TODO: refactor this after using DataModelArray
			this.updateRequest();
			return this.loadItems();
		}
	}

	return MultiFragmentGrid;
}
